export function overlayBrightnessCss(overlay?: boolean): string {
  return overlay ? 'brightness-75' : '';
}
